<template>
  <div class="relation-graph-container" ref="graphContainer">
    <div class="loading-wrapper" v-if="loading">
      <a-spin tip="图谱加载中......">
        <a-icon slot="indicator" type="loading" wrapperClassName="loading-wrapper" />
      </a-spin>
    </div>
    <Header></Header>

    <div v-show="detailContent.id" class="grap-details-expand" @click="handleExpand(0)">展开</div>
    <div class="grap-details" :class="[`expand-status-${expandValue}`]" v-if="detailContent.id">
      <div class="detail-header">
        <div class="button-item expand" @click="handleExpand(1, true)">展开</div>
        <div class="detail-name">{{ detailContent.name }}</div>
        <div class="button-item put" @click="handleExpand(-1, true)">收起</div>
      </div>
      <div class="detail-content">
        <div class="scroll">
          <!-- 专业定位 -->
          <div class="item-text" v-if="detailContent.position">
            <div class="block-header">
              <div class="block-left">
                <div class="block-name">专业定位</div>
              </div>
            </div>
            <div class="block-content">
              <p>
                {{ detailContent.position }}
              </p>
            </div>
          </div>
          <!-- 其余略（保持原样） -->
          <div class="item-text" v-if="detailContent.target">
            <div class="block-header">
              <div class="block-left">
                <div class="block-name">专业育人目标</div>
              </div>
            </div>
            <div class="block-content">
              <p>{{ detailContent.target }}</p>
            </div>
          </div>

          <div class="item-text" v-if="showWordCloud">
            <div class="block-header">
              <div class="block-left">
                <div class="block-name">适用的专业思政元素</div>
              </div>
              <div class="block-button" @click="handleSzysMore()">查看全部</div>
            </div>
            <div class="block-content">
              <div class="wordCloud" ref="cloudChart"
                :style="`height:${detailContent.szys.length < 20 ? '240px' : '400px'}`">
              </div>
            </div>
          </div>

          <div class="item-text" v-if="detailContent.duty">
            <div class="block-header">
              <div class="block-left">
                <div class="block-name">岗位职责</div>
              </div>
            </div>
            <div class="block-content">
              <p>{{ detailContent.duty }}</p>
            </div>
          </div>

          <div class="item-text" v-if="detailContent.ability">
            <div class="block-header">
              <div class="block-left">
                <div class="block-name">核心能力具体内容</div>
              </div>
            </div>
            <div class="block-content">
              <p>{{ detailContent.ability }}</p>
            </div>
          </div>

          <div class="item-text" v-if="detailContent.ability_target">
            <div class="block-header">
              <div class="block-left">
                <div class="block-name">思政目标</div>
              </div>
            </div>
            <div class="block-content">
              <p>{{ detailContent.ability_target }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="filter-box">
      <div class="filter-item" @click="handleCurrent(index)" :class="{ active: index == filterIndex }"
        v-for="item, index in filterData" :key="index">
        {{ item.name }}
      </div>
    </div>

    <div ref="chartWrapper" class="chart-wrapper" @dblclick="resetPanZoom" :style="wrapperStyle">
      <div ref="chart" class="chart-container" :class="[`position-${expandValue + 2}`]"
        :style="!allowClick ? 'pointer-events:none' : ''"></div>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../elementGraph/Header.vue'
import Footer from '../../components/Footer.vue'
import services from '../../assets/js/services'
import { mapState, mapActions, mapMutations } from 'vuex'

import * as echarts from 'echarts';
import 'echarts-wordcloud'

export default {
  name: 'majorGraph',
  components: { Header, Footer },
  data() {
    return {
      school_code: localStorage.getItem("schoolCode"),
      expandValue: -1,
      loading: false,
      chart: null,
      data: [],
      filterIndex: 0,
      lastFilterIndex: 0,
      filterData: [],
      detailContent: {},
      cloudChart: null,
      showWordCloud: true,
      originalSzys: [],

      // pan/zoom 状态
      pan: { x: 0, y: 0 },  // 平移偏移（px）
      scale: 1,   // 缩放比例
      minScale: 0.5,
      maxScale: 3,
      isDragging: false,
      lastPointer: null,  // 拖拽记录
      lastPinchDistance: 0,
      mouseDownPos: null,   // 记录按下位置
      allowClick: true,     // 是否允许触发 ECharts 的点击
      major_id: "",
    }
  },
  computed: {
    ...mapState({
      appsUserInfo: state => state.appsLogin.appsUserInfo,
      schoolMenu: state => state.appsLogin.schoolMenu,
    }),
    open_element() {
      return this.schoolMenu?.open_element
    },
    open_ability() {
      return this.schoolMenu?.open_ability
    },
    // 绑定到 wrapper 的 style（用于动态 transform）
    wrapperStyle() {
      return {
        transform: `translate(${this.pan.x}px, ${this.pan.y}px) scale(${this.scale})`,
        transformOrigin: '0 0',
        touchAction: 'none' // 禁掉默认手势，便于 pointer 处理
      };
    }
  },
  async mounted() {
    await this.getGroupFilter()
    await this.getGraphData(this.filterIndex)
    window.addEventListener('resize', this.handleResize);
    this.initPanZoom(); // 初始化拖拽/缩放事件
    let that = this
    setTimeout(function () {
      if (that.open_ability == 2) that.$router.push(`/${that.school_code}/zy/noauth`)
    }, 1000)
  },
  beforeDestroy() {
    this.chart && this.chart.dispose();
    this.cloudChart && this.cloudChart.dispose();
    window.removeEventListener('resize', this.handleResize);
    this.destroyPanZoom();
  },
  methods: {
    // Vuex action / mutation 映射
    ...mapActions(["goAppsDetailsBeforeLogin", "schoolLoginRedirect", "getAppsImageCaptcha",]),
    ...mapMutations(["setDownloadIdList", "setAppsLoginVisible"]),

    // 获取分组过滤器
    async getGroupFilter() {
      let res = await services.getGroupFilter({ school_code: this.school_code })
      if (res.code == '0000' && res.data.group_list) {
        this.filterData = res.data.group_list
      }
    },

    // 初始化词云（右侧详情）
    initWordCloud() {
      // 如果已有实例先销毁
      this.cloudChart && this.cloudChart.dispose();

      // 组装数据
      const data = (this.detailContent.szys || []).map(word => {
        const baseValue = word.type == 2 ? 70 : 35;
        return { name: word.name, value: baseValue };
      });

      // 初始化 ECharts 实例并设置配置
      const chartDom = this.$refs.cloudChart;
      this.cloudChart = echarts.init(chartDom);

      const option = {
        backgroundColor: '#fff',
        tooltip: { show: false },
        series: [{
          type: 'wordCloud',
          gridSize: this.detailContent.szys.length < 20 ? 20 : 1,
          sizeRange: this.detailContent.szys.length < 20 ? [16, 24] : [12, 22],
          rotationRange: [0, 0],
          textStyle: {
            fontWeight: 'bold',
            color() {
              const colors = ['#345A91', '#ABB2B4', '#F56D69', '#CD8230', '#E98452', '#4D8BFF', '#EEB741', '#ED9C75', '#5CCCFB', '#61AEF9', '#E1A57F']
              return colors[Math.floor(Math.random() * colors.length)]
            }
          },
          left: 'center',
          top: '0',
          width: '95%',
          height: '95%',
          data
        }]
      }

      this.cloudChart.setOption(option)

      // 点击词云跳转详情页
      this.cloudChart.on('click', (params) => {
        const originalData = this.originalSzys.find(item =>
          item.name == params.data.name || item == params.data.name
        )
        let id = originalData && (originalData.id || originalData._id)
        window.open(`/${this.school_code}/zy/elementGraph?element_id=${id}`)
      })
    },

    // 打开元素详情页
    handleSzysMore() {
      if (this.open_ability == 1 && this.open_element == 1) {
        // 开通了专业能力图谱和校本思政元素图谱的 跳转后选中专业下的“专业品质”
        window.open(`/${this.school_code}/zy/elementGraph?group_id=${this.filterData[this.filterIndex].id}&major_id=${this.major_id}&element_first_name=专业品质`)
      } else {
        window.open(`/${this.school_code}/zy/elementGraph?group_id=${this.filterData[this.filterIndex].id}&major_id=${this.major_id}`)
      }
    },
    loginModal(val) {
      let that = this;
      // 如果需要统一登录,跳转
      let param = {
        format: "json",
        school_code: that.school_code,
        from: window.location.href,
      };
      that.schoolLoginRedirect(param).then(async (res) => {
        if (
          res.code == "0000" &&
          res.data &&
          !(res.data.redirect.indexOf(services.APPS_WEB) > -1)
        ) {
          return window.open(res.data.redirect, "_self");
        } else {
          await that.setAppsLoginVisible(val);
          if (val) {
            await that.getAppsImageCaptcha();
          }
        }
      });
    },
    // 切换当前过滤项
    async handleCurrent(index) {
      if (!this.appsUserInfo || !this.appsUserInfo.id) return this.loginModal(true)
      await this.getGraphData(index)
      if (this.data && this.data.length > 0) {
        this.detailContent = {}
        this.handleExpand(-1)
      } else {
        return
      }
    },

    // 控制右侧详情面板展开/收起
    handleExpand(value, calculate) {
      if (!this.appsUserInfo || !this.appsUserInfo.id) return this.loginModal(true)

      let that = this
      // 保持原逻辑（你原来有一段不清楚的 scrollNode 处理，我保留空置）
      let scrollNode = document.getElementsByClassName("scroll")[0]
      if (scrollNode) scrollNode = 0

      let oldVal = that.expandValue
      if (calculate) {
        that.expandValue += value
        if (value == 0) that.expandValue = 0
        if (value >= 1) that.expandValue = 1
        if (value < -1) that.expandValue = -1
      } else {
        that.expandValue = value
      }

      // 展开/收起后调整词云大小
      setTimeout(function () {
        if (oldVal != value) that.cloudChart && that.cloudChart.resize()
      }, 300)
    },

    // 根据 group 获取图谱数据并初始化图表
    async getGraphData(index) {
      this.loading = true
      let params = {
        school_code: this.school_code,
        group_id: this.filterData[index ?? this.filterIndex].id
      }
      let res = await services.getGroupGraph(params)
      if (res.code == '0000') {
        if (res.data) {
          this.filterIndex = index
          this.data = await this.buildData(res.data)
          await this.initChart();
        } else {
          this.$message.info("该专业群/学院下暂未设置专业")
          this.loading = false
          this.filterIndex = this.lastFilterIndex
          return
        }
      } else {
        this.loading = false
      }
    },

    // 构建 sunburst 所需的层级数据
    buildData(originalData) {
      if (originalData && originalData.length > 0) {
        const dataMap = new Map();
        const result = [];

        // 建立 id -> node 映射
        originalData.forEach(item => {
          dataMap.set(item.id, { id: item.id, name: item.name, children: [], value: 0 });
        });

        // 构建父子关系
        originalData.forEach(item => {
          if (item.pid && dataMap.has(item.pid)) {
            const parent = dataMap.get(item.pid);
            parent.children.push(dataMap.get(item.id));
          }
        });

        // 按专业分组并过滤空名称节点
        const majorGroups = new Map();
        originalData.forEach(item => {
          if (item.pid && item.pid.startsWith('g_')) {
            if (!majorGroups.has(item.pid)) majorGroups.set(item.pid, []);
            if (item.name) majorGroups.get(item.pid).push(dataMap.get(item.id));
          }
        });

        // 递归处理节点，计算 value
        function processNode(node) {
          if (node.children && node.children.length > 0) {
            const processedChildren = node.children.filter(child => child.name).map(child => processNode(child));
            const totalValue = processedChildren.reduce((sum, child) => sum + child.value, 0);
            return { id: node.id, name: node.name, value: totalValue, children: processedChildren.length > 0 ? processedChildren : undefined };
          } else {
            return { id: node.id, name: node.name, value: 1 };
          }
        }

        majorGroups.forEach((majors) => {
          majors.forEach(major => {
            if (major.name) result.push(processNode(major));
          });
        });

        this.loading = false
        return result;
      } else {
        this.$message.info("该专业群/学院下暂未设置专业")
      }
    },

    // 适配fontSize
    computeFontSize() {
      const baseWidth = 1920;
      const currentWidth = this.$refs.chartDom.offsetWidth;

      // 比例缩放，例如在 1920 下是 14px
      const scale = currentWidth / baseWidth;
      let fontSize = Math.round(14 * scale);

      // 最小、最大限制
      fontSize = Math.max(10, Math.min(fontSize, 18));

      return fontSize;
    },

    // 初始化 ECharts sunburst 图
    initChart() {
      // 递归给每个子节点设置颜色
      function setColor(node, baseColor, depth = 0, siblingIndex = 0) {
        // 颜色变浅函数
        const adjustColor = (color, percent) => {
          const num = parseInt(color.slice(1), 16);
          const amt = Math.round(2.55 * percent);
          const R = Math.min(255, Math.max(0, (num >> 16) + amt));
          const G = Math.min(255, Math.max(0, (num >> 8 & 0x00FF) + amt));
          const B = Math.min(255, Math.max(0, (num & 0x0000FF) + amt));
          return "#" + ((1 << 24) + (R << 16) + (G << 8) + B).toString(16).slice(1);
        };

        // 根据层级决定基础深浅
        let adjustPercent = 0;
        if (depth == 0) adjustPercent = 30;      // 一级：浅
        else if (depth == 2) adjustPercent = 45;  // 三级：更浅
        // 二级深度使用原色

        // 只在二级层级添加兄弟元素差异
        let siblingAdjust = 0;
        if (depth == 1) {
          siblingAdjust = siblingIndex * 5;  // 二级兄弟元素差异5%
          // adjustPercent = 10
        }

        const currentColor = adjustColor(baseColor, adjustPercent + siblingAdjust);

        node.itemStyle = { color: currentColor };
        if (depth == 0) node.itemStyle['opacity'] = 0.6
        // else if (depth == 1) node.itemStyle['opacity'] = 0.7
        else if (depth == 2) node.itemStyle['opacity'] = 0.125


        if (node.children) {
          node.children.forEach((child, index) => {
            setColor(child, baseColor, depth + 1, index);
          });
        }
      }


      const colors = [
        "#e83141",
        "#ee6928",
        "#f67b03",
        "#9db10f",
        "#32b544",
        "#15b0a6",
        "#4685f6",
        "#4c71bb",
        "#7b49bf",
        "#954dbf"
      ];

      // 给数据设置颜色
      if (this.data.length <= 4) {
        // 当数据量小于等于4时，随机取四个颜色
        const shuffledColors = [...colors].sort(() => Math.random() - 0.5).slice(0, 4);
        this.data.forEach((item, index) => {
          setColor(item, shuffledColors[index], 0, index);
        });
      } else {
        // 当数据量大于4时，按顺序取颜色
        this.data.forEach((item, index) => {
          setColor(item, colors[index % colors.length], 0, index);
        });
      }

      // 初始化 echarts 实例并设置 option
      const chartDom = this.$refs.chart;
      this.chart = echarts.init(chartDom, null, { renderer: 'svg' })

      const option = {
        tooltip: {
          trigger: 'item',
          formatter: (p) => `${p.name}`
        },
        series: {
          type: 'sunburst',
          data: this.data,
          radius: [0, '100%'],
          sort: undefined,
          emphasis: {
            focus: 'descendant',
            itemStyle: {
              shadowBlur: 10,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          },
          nodeClick: false,
          label: {
            textBorderColor: 'none',
            textBorderWidth: 0,
            // fontSize: window.innerWidth >= 1920 ? 14 : window.innerWidth >= 1600 ? 12 : 10,
            fontSize: 14,
            color: "#333"
          },
          levels: [
            { r0: '0%', r: '1%' },
            { r0: '3%', r: '30%', label: { position: 'inside', align: 'center', overflow: 'break', width: 100, height: 30 }, itemStyle: { borderWidth: 0 } },
            { r0: '29%', r: '50%', label: { position: 'inside', align: 'center', color: "#fff", overflow: 'break', width: 100, height: 30 }, itemStyle: { borderWidth: 0 } },
            { r0: '49%', r: '60%', label: { align: 'left', position: 'inside', padding: 10, silent: false }, itemStyle: { borderWidth: 0 } }
          ]
        }
      };
      this.chart.setOption(option);

      this.resetPanZoom()

      // 节点点击事件绑定 展示详情并加粗文字
      this.chart.on('click', (params) => {
        let that = this
        this.onNodeClick(params.data);
        setTimeout(() => that._onMouseUp(), 500);
        this.handleTextBold(params);
      });
    },

    // 点击后文字加粗
    handleTextBold(params) {
      const option = this.chart.getOption();
      const updateBoldStyle = (data) => {
        return data.map(item => {
          if (item.id == params.data.id) {
            return { ...item, label: { ...item.label, fontWeight: 'bold' } };
          } else if (item.children) {
            return { ...item, children: updateBoldStyle(item.children), label: { ...item.label, fontWeight: 'normal' } };
          } else {
            return { ...item, label: { ...item.label, fontWeight: 'normal' } };
          }
        });
      };

      const updatedData = updateBoldStyle(option.series[0].data);
      this.chart.setOption({ series: [{ data: updatedData }] });
    },

    // 从 id 字符串中截取真实 id（ m_123 -> 123）
    getId(id) {
      return id.split("_")[1]
    },

    // 点击节点请求详细信息, 并展示右侧面板
    async onNodeClick(node, e) {
      if (!this.appsUserInfo || !this.appsUserInfo.id) return this.loginModal(true)
      this.handleExpand(0)
      if (this.detailContent.id != node.id) {
        if (node.id.startsWith("m_")) this.major_id = this.getId(node.id)
        this.loading = true;
        this.showWordCloud = false;
        this.detailContent = {
          id: node.id,
          name: node.name,
          position: "",
          target: "",
          szys: [],
        };

        let params = {
          school_code: this.school_code,
          open_element: this.open_element,
          type: "",
          id: this.getId(node.id)
        }

        // 根据节点类型设置请求类型
        if (node.id.startsWith('m_')) {
          this.showWordCloud = true;
          if (this.open_element == 1 && this.open_ability == 1) params['name'] = '专业品质'
          params['type'] = 1
        } else if (node.id.startsWith('j_')) {
          params['type'] = 2
        } else if (node.id.startsWith('a_')) {
          params['type'] = 3
        }

        // 请求详情
        let res = await services.getGroupDetail(params)
        if (res.code == "0000" && res.data) {
          this.detailContent = {
            id: this.getId(node.id),
            name: node.name,
            position: 'major_position' in res.data ? (res.data.major_position || '暂未设置该项信息') : false,
            target: 'major_target' in res.data ? (res.data.major_target || '暂未设置该项信息') : false,
            duty: 'job_duty' in res.data ? (res.data.job_duty || '暂未设置该项信息') : false,
            ability: 'ability_content' in res.data ? (res.data.ability_content || '暂未设置该项信息') : false,
            ability_target: 'ability_target' in res.data ? (res.data.ability_target || '暂未设置该项信息') : false
          };

          const cloudData = res.data.major_elements || [];
          if (cloudData.length > 0) {
            this.detailContent.szys = cloudData
            this.originalSzys = cloudData
            setTimeout(() => { this.initWordCloud(); }, 0)
          } else {
            this.detailContent.szys = [];
            this.originalSzys = []
            this.showWordCloud = false;
            this.cloudChart && this.cloudChart.dispose();
          }
        }
        this.loading = false;
      }
    },

    // 窗口尺寸或容器变化时调整 echarts
    handleResize() {
      this.chart && this.chart.resize();
      this.cloudChart && this.cloudChart.resize && this.cloudChart.resize();
    },

    // 初始化鼠标事件
    initPanZoom() {
      const wrapper = this.$refs.chartWrapper;
      if (!wrapper) return;
      // 绑定鼠标按下/移动/抬起事件实现拖拽
      wrapper.addEventListener('mousedown', this._onMouseDown);
      window.addEventListener('mousemove', this._onMouseMove);
      window.addEventListener('mouseup', this._onMouseUp);
      // 绑定滚轮缩放、阻止默认滚动
      wrapper.addEventListener('wheel', this._onWheel, { passive: false });
      // 双击复位
      wrapper.addEventListener('dblclick', this.resetPanZoom);
    },

    // 卸载鼠标事件
    destroyPanZoom() {
      const wrapper = this.$refs.chartWrapper;
      if (!wrapper) return;
      wrapper.removeEventListener('mousedown', this._onMouseDown);
      window.removeEventListener('mousemove', this._onMouseMove);
      window.removeEventListener('mouseup', this._onMouseUp);
      wrapper.removeEventListener('wheel', this._onWheel);
      wrapper.removeEventListener('dblclick', this.resetPanZoom);
    },

    // 鼠标按下：开始拖拽
    _onMouseDown(e) {
      e.preventDefault();
      this.isDragging = true;
      // 记录按下坐标，用来判断拖动距离
      this.mouseDownPos = { x: e.clientX, y: e.clientY };
      this.lastPointer = { x: e.clientX, y: e.clientY };
    },

    // 鼠标移动：拖拽平移
    _onMouseMove(e) {
      if (!this.isDragging || !this.lastPointer) return;

      const dx = e.clientX - this.lastPointer.x;
      const dy = e.clientY - this.lastPointer.y;

      // 只要移动超过一定阈值
      if (Math.abs(e.clientX - this.mouseDownPos.x) > 5 ||
        Math.abs(e.clientY - this.mouseDownPos.y) > 5) {

        // 移动过就不触发 click
        this.allowClick = false;
      }

      this.pan.x += dx;
      this.pan.y += dy;

      this.lastPointer = { x: e.clientX, y: e.clientY };
    },

    // 鼠标抬起：结束拖拽
    _onMouseUp() {
      this.isDragging = false;
      this.lastPointer = null;

      // 如果几乎没移动 → 允许 click
      // 如果移动过 → 禁止 click
      if (this.allowClick === false) {
        // 松开后重置
        setTimeout(() => this.allowClick = true, 0);
      }
    },

    // 滚轮：在光标位置缩放
    _onWheel(e) {
      e.preventDefault();
      const delta = -e.deltaY;
      const factor = 1 + delta / 1200; // 缩放灵敏度，可按需调整
      this._applyScaleAtPoint(factor, { x: e.clientX, y: e.clientY });
    },

    // 缩放实现：保持鼠标点位不动，并改变 chart 容器实际尺寸，调用 chart.resize()
    _applyScaleAtPoint(factor, clientPoint) {
      const oldScale = this.scale;
      let newScale = oldScale * factor;

      // 限制缩放范围
      newScale = Math.max(this.minScale, Math.min(this.maxScale, newScale));
      if (Math.abs(newScale - oldScale) < 1e-6) return;

      const wrapper = this.$refs.chartWrapper;
      const rect = wrapper.getBoundingClientRect();

      // 缩放中心相对于 wrapper 的坐标
      const cx = clientPoint.x - rect.left;
      const cy = clientPoint.y - rect.top;

      const ratio = newScale / oldScale;

      // 调整 pan 以保持缩放点视觉位置不变
      this.pan.x -= (ratio - 1) * cx;
      this.pan.y -= (ratio - 1) * cy;

      // 更新 scale
      this.scale = newScale;

      // 记录 baseWidth/baseHeight（只记录一次）
      const baseW = this.baseWidth || wrapper.clientWidth;
      const baseH = this.baseHeight || wrapper.clientHeight;
      if (!this.baseWidth) this.baseWidth = baseW;
      if (!this.baseHeight) this.baseHeight = baseH;

      // 计算新的真实 canvas 尺寸，直接设置并触发 echarts.resize()
      const newWidth = baseW * newScale;
      const newHeight = baseH * newScale;
      const chartEl = this.$refs.chart;
      chartEl.style.width = newWidth + 'px';
      chartEl.style.height = newHeight + 'px';

      // 重新绘制，避免文字和图形模糊
      this.chart.resize();
    },

    // 双击复位：恢复平移与缩放，并恢复 canvas 大小
    resetPanZoom() {

      let that = this
      setTimeout(() => that._onMouseUp(), 50);

      this.pan.x = 0;
      this.pan.y = 0;
      this.scale = 1;

      // 恢复画布为基准尺寸
      const chartEl = this.$refs.chart;
      if (this.baseWidth && this.baseHeight) {
        chartEl.style.width = this.baseWidth + 'px';
        chartEl.style.height = this.baseHeight + 'px';
      } else {
        // 若未记录 base，则使用 wrapper 当前尺寸
        const wrapper = this.$refs.chartWrapper;
        chartEl.style.width = wrapper.clientWidth + 'px';
        chartEl.style.height = wrapper.clientHeight + 'px';
      }

      // 触发 resize
      this.chart.resize();
    }
  }
}
</script>

<style lang="less" scoped>
.relation-graph-container {
  width: 100vw;
  height: 100vh;
  background: url('../../assets/image/majorGraph/background.png') no-repeat center/cover;
  overflow: hidden;
  position: relative;

  &:has(.login) .rel-node-peel {
    box-shadow: none;
  }

  .spin-fixed {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1002;
  }
}

.ant-select-dropdown {
  border-radius: 0;
}

/deep/.footer-box {
  width: 100%;
  position: fixed !important;
  left: 0;
  bottom: 0;
  z-index: 1000;
  background: #e0e3e8;

  .flex-box {
    display: none;
  }

  .copyright {
    color: #aeaeae;

    span,
    a {
      font-size: 10px;
      color: #aeaeae;
    }
  }
}

.grap-details-expand {
  width: 64px;
  height: 32px;
  background: #ffffff;
  border-radius: 2px;
  border: 1px solid #dcdcdd;
  color: #b1abac;
  cursor: pointer;
  position: fixed;
  top: 78px;
  right: 27px;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;

  &::before {
    content: '';
    display: inline-block;
    width: 11px;
    height: 10px;
    background: url('../../assets/image/elementGraph/button-expand.png');
    margin-right: 7px;
  }

  &:hover {
    color: #dd363a;

    &::before {
      background: url('../../assets/image/elementGraph/button-expand-active.png');
    }
  }
}

.grap-details {
  position: fixed;
  height: calc(100vh - 48px - 40px);
  top: 48px;
  right: 0;
  z-index: 1000;
  background: #ffffff;
  box-shadow: 0px 4px 10px 0px rgba(125, 126, 130, 0.22);
  border-radius: 0px 0px 0px 4px;
  border: 1px solid #eae8e8;
  transition: width 0.3s;
  display: flex;
  flex-direction: column;

  &.expand-status--1 {
    width: 0;
    white-space: nowrap;

    .put {
      opacity: 0;
      pointer-events: none;
    }
  }

  &.expand-status-0 {
    width: 440px;
    opacity: 1;
  }

  &.expand-status-1 {
    opacity: 1;
    width: 803px;

    .expand {
      opacity: 0;
      pointer-events: none;
    }

    .detail-name {

      &::before,
      &::after {
        display: inline-block !important;
      }
    }
  }

  &::before {
    content: '';
    display: inline-block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100px;
    background: linear-gradient(0deg, #ffffff 36%, #ffeaec 100%);
    border-radius: 0px 0px 0px 4px;
  }

  &>div {
    position: relative;
    z-index: 1;
  }

  .detail-header {
    display: flex;
    justify-content: space-between;
    padding: 15px 20px 0;

    .button-item {
      margin-top: 3px;
      font-size: 12px;
      color: #b1abac;
      cursor: pointer;
      white-space: nowrap;

      &::before,
      &::after {
        content: '';
        display: inline-block;
        width: 11px;
        height: 10px;
      }

      &:hover {
        color: #dd363a;
      }

      &.expand {
        &::before {
          background: url('../../assets/image/elementGraph/button-expand.png') no-repeat center/cover;
          margin-right: 7px;
        }

        &:hover::before {
          background: url('../../assets/image/elementGraph/button-expand-active.png') no-repeat center/cover;
        }
      }

      &.put {
        &::after {
          background: url('../../assets/image/elementGraph/button-put.png') no-repeat center/cover;
          margin-left: 7px;
        }

        &:hover::after {
          background: url('../../assets/image/elementGraph/button-put-active.png') no-repeat center/cover;
        }
      }
    }

    .detail-name {
      font-weight: bold;
      font-size: 17px;
      color: #ab0004;
      // letter-spacing: 5px;
      text-align: center;
      position: relative;

      &::before,
      &::after {
        content: '';
        width: 77px;
        height: 17px;
        vertical-align: -3px;
        display: none;
      }

      &::before {
        background: url('../../assets/image/elementGraph/large-left.png') no-repeat center/cover;
        margin-right: 50px;
      }

      &::after {
        background: url('../../assets/image/elementGraph/large-right.png') no-repeat center/cover;
        margin-left: 50px;
      }
    }
  }

  .detail-content {
    flex: 1;
    overflow: hidden;
    padding: 18px 10px 0 20px;

    .scroll {
      height: 100%;
      overflow-x: hidden;
      overflow-y: auto;
      padding-right: 5px;
      padding-bottom: 21px;

      &::-webkit-scrollbar-track-piece {
        background: transparent;
      }

      &::-webkit-scrollbar-thumb {
        background: rgba(0, 0, 0, 0.5);
        border-radius: 10px;
      }
    }

    .block-header {
      width: 100%;
      height: 30px;
      background: #fdf1ec;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 13px 0 9px;

      .block-left {
        display: flex;
        align-items: center;

        &::before {
          content: '';
          display: inline-block;
          width: 14px;
          height: 14px;
          background: url('../../assets/image/elementGraph/icon-nhlj.png');
          margin-right: 9px;
        }

        .block-name {
          font-weight: bold;
          font-size: 15px;
          color: #543129;
        }

        .block-num {
          font-size: 12px;
          color: #b8262a;
          margin-left: 11px;
        }
      }

      .block-button {
        font-size: 14px;
        color: #b60e0f;
        cursor: pointer;
      }
    }

    .item-text {
      margin-bottom: 18px;

      .block-content {
        margin-top: 8px;
        width: 100%;
        background: #f7f8fd;
        font-size: 14px;
        color: #666666;
        line-height: 22px;
        padding: 13px 18px;
        white-space: pre-wrap;

        &:has(.wordCloud) {
          background: transparent;
          padding: 0;
        }

        .wordCloud {
          width: 100%;
          height: 400px;
        }
      }
    }
  }
}

/deep/ .login-sub-box {
  z-index: 1001 !important;
  background: #fff;
}

.loading-wrapper {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 255, 255, 0.5);
  z-index: 1002;

  .ant-spin {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 14px;
    color: #dd363a;
  }
}

/deep/ .login-outer-box {
  z-index: 1002;
}

// 火狐浏览器滚动条样式
@-moz-document url-prefix() {
  .scroll {
    scrollbar-width: thin;
  }
}

.filter-box {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  left: 50px;
  z-index: 10;
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 45px - 40px - 200px);
  overflow-y: auto;
  padding-left: 32px;

  .filter-item {
    width: 274px;
    height: 52px;
    background: url('../../assets/image/majorGraph/item.png') no-repeat center/cover;
    text-align: center;
    line-height: 52px;
    font-weight: bold;
    font-size: 20px;
    color: #484848;
    transform: translateX(0);
    cursor: pointer;
    transition: transform 0.5s;

    &:not(:last-child) {
      margin-bottom: 21px;
    }

    &.active,
    &:hover {
      transform: translateX(-32px);
      background: url('../../assets/image/majorGraph/item-active.png') no-repeat center/cover;
      color: #ffffff;
    }
  }
}

.chart-wrapper {
  width: 100%;
  height: auto;
  // overflow: hidden;
  display: block;
  user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;

  .chart-container {
    width: 100%;
    height: 140vh;
    left: 54%;
    transform: translate(-50%, -18%);
    transition: left 0.3s;

    &.position-1 {
      left: 54%;
    }

    &.position-2 {
      left: 45.5%;
    }

    &.position-3 {
      left: 37%;
    }

    transition: transform 0s;
  }
}

.relation-graph-container {
  position: relative;
}
</style>